module.exports = __webpack_public_path__ + "img/page_logo.cf952cec.png";